import React from 'react';
export const CompositeFieldContext = /*#__PURE__*/ React.createContext(null);

//# sourceMappingURL=CompositeFieldContext.js.map